import { TLandAreaUnitType } from '../index';
import { IOffer } from '../types';

const landStatus: { [key: string]: string } = {
  individualHousingConstruction: 'ИЖС',
  gardening: 'садоводство',
  gardeningNonProfitPartnership: 'СНТ',
  farm: 'фермерское хоз-во',
  suburbanNonProfitPartnership: 'ДНП',
  settlements: 'участок поселений',
  industrialLand: 'земля промназначения',
  investmentProject: 'инвестпроект',
};

export function suburbanHelper(offer: IOffer) {
  return {
    getSteadStatus: () => getSteadStatus(offer),
    getLandArea: () => getLandArea(offer),
  };
}

function getSteadStatus(offer: IOffer) {
  if (offer.land && offer.land.status && offer.land.status in landStatus) {
    return landStatus[offer.land.status];
  } else {
    return undefined;
  }
}

function getLandArea(offer: IOffer) {
  if (offer.land && offer.land.area) {
    const unitTypes: { [K in TLandAreaUnitType]: string } = {
      hectare: 'га',
      sotka: 'сот.',
    };

    return `участок ${Number(offer.land.area)} ${
      (offer.land.areaUnitType && unitTypes[offer.land.areaUnitType]) || 'сот.'
    }`;
  }

  return undefined;
}
